(function () {
  var body = $("body");
  var side = $(".side-wishlist-placeholder");
  var full = $(".full-wishlist-placeholder");
  var errorTimeout;
  var loading = false;

  function close() {
    side.removeClass("show").attr("aria-hidden", "true");
    $(".user-favorite").attr("aria-expanded", "false");
    if (!$("#cart-container").hasClass("show")) {
      body.removeClass("overlay");
    }
  }

  function open() {
    $("#cart-container").removeClass("show");
    side.addClass("show").attr("aria-hidden", "false");
    $(".user-favorite").attr("aria-expanded", "true");
    body.addClass("overlay");
  }

  function showError(container) {
    container.find(".wishlist-request-error").remove();
    container.prepend('<div class="wishlist-request-error alert alert-danger" role="alert">Seznama želja ni bilo mogoče posodobiti. Poskusite znova.</div>');
  }

  function render(container, html) {
    if (!$.trim(html)) {
      showError(container);
      return;
    }
    container.html(html);
  }

  function refreshCount() {
    return $.getJSON("/wishlist/status").done(function (data) {
      $(".wishlist-count").text(data.wishlist > 0 ? data.wishlist : "").toggle(data.wishlist > 0);
      var productIds = data.product_ids || [];
      $(".add-to-wishlist-button").each(function () {
        var button = $(this);
        var saved = productIds.indexOf(String(button.data("id"))) !== -1;
        button.toggleClass("in-wishlist", saved);
        button.closest(".product").toggleClass("in-wishlist", saved);
        var label = button.find(".wishlist-button-label");
        label.text(label.attr(saved ? "data-label-saved" : "data-label-save"));
      });
    });
  }

  function setFullLoading(container, active) {
    if (!container.is(full)) { return; }
    var pending = (container.data("wishlist-requests") || 0) + (active ? 1 : -1);
    container.data("wishlist-requests", pending);
    container.find(".list-loader").remove();
    container.toggleClass("wishlist-loading", pending > 0);
    if (pending > 0) {
      container.attr("aria-busy", "true");
      var target = container.find(".wishlist-full-products-list");
      if (!target.length) { target = container; }
      target.prepend('<div class="list-loader" aria-hidden="true"><div class="inner"></div></div>');
    } else {
      container.removeAttr("aria-busy");
    }
  }

  function load(container, type) {
    setFullLoading(container, true);
    return $.get("/wishlist/wishlist", { type: type })
      .done(function (html) { render(container, html); })
      .fail(function () { showError(container); })
      .always(function () { setFullLoading(container, false); });
  }

  function mutate(action, data, container, type) {
    if (loading) { return; }
    loading = true;
    container.attr("aria-busy", "true");
    setFullLoading(container, true);
    $.post("/wishlist/" + action + "?type=" + type, data)
      .done(function (html) {
        render(container, html);
        if (type === "side") { open(); }
        refreshCount();
        if (full.length && type !== "full") { load(full, "full"); }
        if (type !== "side") { load(side, "side"); }
      })
      .fail(function () {
        showError(container);
        if (type === "side") { open(); }
      })
      .always(function () {
        loading = false;
        if (type === "full") { setFullLoading(container, false); }
        else { container.removeAttr("aria-busy"); }
      });
  }

  body.on("click.wishlist", ".add-to-wishlist-button", function (event) {
    event.preventDefault();
    var button = $(this);
    var message = button.siblings(".wishlist-error");
    if (message.length) {
      clearTimeout(errorTimeout);
      $(".wishlist-error").removeClass("is-visible").addClass("is-hidden");
      message.removeClass("is-hidden").addClass("is-visible");
      errorTimeout = setTimeout(function () {
        message.removeClass("is-visible").addClass("is-hidden");
      }, 3000);
      return;
    }
    mutate("add", {
      product_id: button.data("id"),
      quantity: button.closest(".product-show").find(".add-to-wishlist-quantity").val() || 1,
      list_type: "wishlist"
    }, side, "side");
  });

  body.on("click.wishlist", ".user-favorite", function (event) {
    event.preventDefault();
    if (side.hasClass("show")) { close(); return; }
    open();
    load(side, "side");
  });

  side.on("click.wishlist", ".close-slide, #side-wishlist-close", function (event) {
    event.preventDefault();
    close();
  });
  $(document).on("keydown.wishlist", function (event) {
    if (event.key === "Escape" && side.hasClass("show")) { close(); }
  });

  side.add(full).on("click.wishlist", ".remove-item", function (event) {
    event.preventDefault();
    var container = $(event.delegateTarget);
    mutate("remove", { product_id: $(this).closest(".product").data("id") },
      container, container.is(full) ? "full" : "side");
  });

  // Wishlist rows arrive after Cart's initial button binding; request the product-page modal.
  full.on("click.wishlist", ".add-to-cart-button", function (event) {
    event.preventDefault();
    var button = $(this);
    if (button.data("pending")) { return; }
    button.data("pending", true);
    $.post("/cart/add", {
      id: button.data("id"),
      qty: button.closest(".product").find(".add-to-cart-quantity").val() || 1,
      mobile: true
    }).done(function (html) {
      if (!$.trim(html)) { showError(full); return; }
      full.find(".wishlist-request-error").remove();
      $("#cart-container").removeClass("show");
      close();
      $("#addToCartPopup").html(html).modal("show");
      getStatus();
    }).fail(function () {
      showError(full);
    }).always(function () { button.removeData("pending"); });
  });

  if (full.length) { load(full, "full"); }
  // Counts are loaded silently; sidebar content is fetched only when it is opened.
  refreshCount();
})();
